// import { createSlice } from '@reduxjs/toolkit';

// const initialState = {
//   cartItems: [],
//   totalItems: 0,
//   totalPrice: 0,
//   cartId: null,
//   cartCount: 0, // Add cartCount to track total number of items
// };

// const cartSlice = createSlice({
//   name: 'cart',
//   initialState,
//   reducers: {
//     setCart: (state, action) => {
//       state.cartItems = action.payload;
//       state.totalItems = action.payload.reduce((acc, item) => acc + item.quantity, 0);
//       state.totalPrice = action.payload.reduce(
//         (acc, item) => acc + (parseFloat(item.price) * item.quantity),
//         0
//       );
//       state.cartCount = action.payload.length; // Update cartCount when setting cart
//     },
//     setCartId: (state, action) => {
//       state.cartId = action.payload;
//     },
//     setTotalPrice: (state, action) => {
//       state.totalPrice = action.payload;
//     },
//     addToCart: (state, action) => {
//       const existingItem = state.cartItems.find(item => item.id === action.payload.id);
//       if (existingItem) {
//         existingItem.quantity += action.payload.quantity || 1;
//       } else {
//         state.cartItems.push({
//           ...action.payload,
//           quantity: action.payload.quantity || 1,
//         });
//       }
//       state.totalItems = state.cartItems.reduce((acc, item) => acc + item.quantity, 0);
//       state.totalPrice = state.cartItems.reduce(
//         (acc, item) => acc + (parseFloat(item.price) * item.quantity),
//         0
//       );
//     },
//     removeFromCart: (state, action) => {
//       state.cartItems = state.cartItems.filter(item => item.id !== action.payload);
//       state.totalItems = state.cartItems.reduce((acc, item) => acc + item.quantity, 0);
//       state.totalPrice = state.cartItems.reduce(
//         (acc, item) => acc + (parseFloat(item.price) * item.quantity),
//         0
//       );
//     },
//     updateQuantity: (state, action) => {
//       const { id, quantity } = action.payload;
//       const item = state.cartItems.find(item => item.id === id);
//       if (item) {
//         item.quantity = quantity;
//       }
//       state.totalItems = state.cartItems.reduce((acc, item) => acc + item.quantity, 0);
//       state.totalPrice = state.cartItems.reduce(
//         (acc, item) => acc + (parseFloat(item.price) * item.quantity),
//         0
//       );
//     },
//     setTotalItems: (state, action) => {
//       state.totalItems = action.payload;
//     },
//     setCartCount: (state, action) => {
//       state.cartCount = action.payload;
//     },
//     incrementCartCount: (state) => {
//       state.cartCount += 1;
//     },
//     decrementCartCount: (state) => {
//       state.cartCount = Math.max(0, state.cartCount - 1);
//     },
//     clearCart: (state) => {
//       state.cartItems = [];
//       state.totalItems = 0;
//       state.totalPrice = 0;
//       state.cartCount = 0;
//       state.cartId = null;
//     },
//   },
// });

// export const {
//   setCart,
//   setCartId,
//   setTotalPrice,
//   addToCart,
//   removeFromCart,
//   updateQuantity,
//   setTotalItems,
//   setCartCount,
//   incrementCartCount,
//   decrementCartCount,
//   clearCart,
// } = cartSlice.actions;

// export default cartSlice.reducer;



// import { createSlice } from '@reduxjs/toolkit';

// const initialState = {
//   cartItems: [],
//   totalPrice: 0, // Optional: You can remove this if managing subtotal in component
// };

// const cartSlice = createSlice({
//   name: 'cart',
//   initialState,
//   reducers: {
//     setCart: (state, action) => {
//       state.cartItems = action.payload;
//       state.totalPrice = action.payload.reduce(
//         (acc, item) => acc + (item.price * item.quantity),
//         0
//       );
//     },
//     addToCart: (state, action) => {
//       const existingItem = state.cartItems.find(item => item.id === action.payload.id);
//       if (existingItem) {
//         existingItem.quantity += action.payload.quantity || 1;
//       } else {
//         state.cartItems.push({
//           ...action.payload,
//           quantity: action.payload.quantity || 1,
//         });
//       }

//       state.totalPrice = state.cartItems.reduce(
//         (acc, item) => acc + (item.price * item.quantity),
//         0
//       );
//     },
//     removeFromCart: (state, action) => {
//       state.cartItems = state.cartItems.filter(item => item.id !== action.payload);
//       state.totalPrice = state.cartItems.reduce(
//         (acc, item) => acc + (item.price * item.quantity),
//         0
//       );
//     },
//     updateQuantity: (state, action) => {
//       const { id, quantity } = action.payload;
//       const item = state.cartItems.find(item => item.id === id);
//       if (item) {
//         item.quantity = quantity;
//       }

//       state.totalPrice = state.cartItems.reduce(
//         (acc, item) => acc + (item.price * item.quantity),
//         0
//       );
//     },
//   },
// });

// export const { addToCart, removeFromCart, updateQuantity, setCart } = cartSlice.actions;
// export default cartSlice.reducer;
//below is my code

// // // redux/cartSlice.js
// // import { createSlice } from '@reduxjs/toolkit';

// // const initialState = {
// //   cartItems: [],
// //   totalPrice: 0,
// // };

// // const cartSlice = createSlice({
// //   name: 'cart',
// //   initialState,
// //   reducers: {
// //     addToCart: (state, action) => {
// //       const existingItem = state.cartItems.find(item => item.id === action.payload.id);
// //       if (existingItem) {
// //         existingItem.quantity += action.payload.quantity || 1;
// //       } else {
// //         state.cartItems.push({ ...action.payload, quantity: action.payload.quantity || 1 });
// //       }
      
// //       // Calculate total price based on updated cart items
// //       state.totalPrice = state.cartItems.reduce((acc, item) => acc + (item.price * item.quantity), 0);
// //     },
// //     removeFromCart: (state, action) => {
// //       state.cartItems = state.cartItems.filter(item => item.id !== action.payload);
      
// //       // Recalculate total price after removal
// //       state.totalPrice = state.cartItems.reduce((acc, item) => acc + (item.price * item.quantity), 0);
// //     },
// //     updateQuantity: (state, action) => {
// //       const { id, quantity } = action.payload;
// //       const item = state.cartItems.find(item => item.id === id);
// //       if (item) {
// //         item.quantity = quantity;
// //       }

// //       // Recalculate total price after update
// //       state.totalPrice = state.cartItems.reduce((acc, item) => acc + (item.price * item.quantity), 0);
// //     },
// //   },
// // });

// // export const { addToCart, removeFromCart, updateQuantity } = cartSlice.actions;
// // export default cartSlice.reducer;


// redux/cartSlice.js
// import { createSlice } from '@reduxjs/toolkit';

// const initialState = {
//   cartItems: [],
//   totalPrice: 0,
//   cartId: null, // 👈 Add this line
// };

// const cartSlice = createSlice({
//   name: 'cart',
//   initialState,
//   reducers: {
//     setCart: (state, action) => {
//       state.cartItems = action.payload;
//       state.totalPrice = action.payload.reduce(
//         (acc, item) => acc + (item.price * item.quantity),
//         0
//       );
//     },
//     setCartId: (state, action) => {
//       state.cartId = action.payload;
//     },
//     addToCart: (state, action) => {
//       const existingItem = state.cartItems.find(item => item.id === action.payload.id);
//       if (existingItem) {
//         existingItem.quantity += action.payload.quantity || 1;
//       } else {
//         state.cartItems.push({
//           ...action.payload,
//           quantity: action.payload.quantity || 1,
//         });
//       }
//       state.totalPrice = state.cartItems.reduce(
//         (acc, item) => acc + (item.price * item.quantity),
//         0
//       );
//     },
//     removeFromCart: (state, action) => {
//       state.cartItems = state.cartItems.filter(item => item.id !== action.payload);
//       state.totalPrice = state.cartItems.reduce(
//         (acc, item) => acc + (item.price * item.quantity),
//         0
//       );
//     },
//     updateQuantity: (state, action) => {
//       const { id, quantity } = action.payload;
//       const item = state.cartItems.find(item => item.id === id);
//       if (item) {
//         item.quantity = quantity;
//       }
//       state.totalPrice = state.cartItems.reduce(
//         (acc, item) => acc + (item.price * item.quantity),
//         0
//       );
//     },
//   },
// });

// export const { setCart, setCartId, addToCart, removeFromCart, updateQuantity } = cartSlice.actions;
// export default cartSlice.reducer;
                            
// cartSlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  cartItems: [],
  totalItems: 0,
  totalPrice: 0,
  cartId: null,
};

const cartSlice = createSlice({
  name: 'cart',
  initialState,
  reducers: {
    setCart: (state, action) => {
      state.cartItems = action.payload;
      state.totalItems = action.payload.length;
      state.totalPrice = action.payload.reduce(
        (acc, item) => acc + (parseFloat(item.price) * item.quantity),
        0
      );
    },
    setCartId: (state, action) => {
      state.cartId = action.payload;
    },
    setTotalPrice: (state, action) => {
      state.totalPrice = action.payload;
    },
    addToCart: (state, action) => {
      const existingItem = state.cartItems.find(item => item.id === action.payload.id);
      if (existingItem) {
        existingItem.quantity += action.payload.quantity || 1;
      } else {
        state.cartItems.push({
          ...action.payload,
          quantity: action.payload.quantity || 1,
        });
      }
      state.totalItems = state.cartItems.length;
      state.totalPrice = state.cartItems.reduce(
        (acc, item) => acc + (parseFloat(item.price) * item.quantity),
        0
      );
    },
    removeFromCart: (state, action) => {
      state.cartItems = state.cartItems.filter(item => item.id !== action.payload);
      
      state.totalItems = state.cartItems.length;
      console.log( state.cartItems,'cartlend')
        console.log( state.totalItems,'cartlend')
      state.totalPrice = state.cartItems.reduce(
        (acc, item) => acc + (parseFloat(item.price) * item.quantity),
        0
      );
    },
    updateQuantity: (state, action) => {
      const { id, quantity } = action.payload;
      const item = state.cartItems.find(item => item.id === id);
      if (item) {
        item.quantity = quantity;
      }
      state.totalItems = state.cartItems.length;
      state.totalPrice = state.cartItems.reduce(
        (acc, item) => acc + (parseFloat(item.price) * item.quantity),
        0
      );
    },
    setTotalItems: (state, action) => {
      state.totalItems = action.payload;
    },
  },
});

export const {
  setCart,
  setCartId,
  setTotalPrice,
  addToCart,
  removeFromCart,
  updateQuantity,
  setTotalItems,
} = cartSlice.actions;
export default cartSlice.reducer;

